export default __webpack_public_path__ + "static/media/heart.a228c112.png";